<template>
    <div class="chartBackClass">
        <div ref="intention" :style="{ width, height }" id="intention"></div>
        <div v-if="!showBool" class="noDataView">暂无数据，敬请期待</div>
    </div>
</template>

<script>
export default {
    props: {
        dataArr: Array,
        width: String,
        height: String,
    },
    data(){
        return{
            showBool: true
        }
    },
    watch:{
        dataArr:{
            handler(){
                // this.chart.setOption(this.option);
                this.newInit();
            }
        }
    },
    created(){
        // setTimeout(() => {
        //     this.newInit()
        // }, 800);
    },
    methods: {
        newInit() {
            const {dataArr} = this
            console.log('dataArr----', dataArr)

            if(dataArr[0] > 0 && dataArr[1] > 0){
                this.showBool = true
                console.log('----222---')
            }else{
                this.showBool = false
                console.log('--3321wwwww')
            }

            let tranArr = []
            let colorArr = ['#BDDB46', '#13FFEE']
            dataArr.forEach((item, index) => {
                let dic = {
                    value: item,
                    itemStyle: {
                        color: colorArr[index]
                    }
                }      
                tranArr.push(dic)          
            });

            let yixiang = ['有意向', '无意向']
            let barColor = ''
            barColor = barColor
            let option = {
                // backgroundColor: "#0f375f",
                barWidth: 1,
                grid: {
                    top: '55%',
                    bottom: '18%',
					left:'20%'
                },
                xAxis: {
                    type: 'value',
                    splitLine: {
                        lineStyle: {
                            color: "#002D4A",
                            type: 'dashed'
                        }
                    },
                    axisTick: {
                        show: false
                    },
                    axisLabel: { //  改变x轴字体颜色和大小
                        textStyle: {
                            color: "#FFFFFF",
                            fontSize: 14
                        }
                    }
                },
                yAxis: {
                    type: 'category',
                    data: yixiang,
                    splitLine: {
                        show: false
                    },
                    axisTick: {
                        show: false
                    },
                    axisLine: { //  改变y轴颜色
                        lineStyle: {
                            color: '#002D4A'
                        }
                    },
                    axisLabel: { //  改变y轴字体颜色和大小
                        //formatter: '{value} m³ ', //  给y轴添加单位
                        textStyle: {
                            color: "rgba(250,250,250,0.6)",
                            fontSize: 14
                        }
                    }
                },
                series: [{
                    type: 'bar',
                    name: "产出",
                    barWidth: 16,
                    barGap: 0,
                    barCategoryGap: '10px',
                    itemStyle: {
                        normal: {
                            label: {
                                show: true, //开启显示
                                position: "right", //在右侧显示
                                textStyle: { //数值样式
                                    color: "#FFFFFF",
                                    fontSize: 13,
                                    // fontWeight: 600
                                }
                            },
                            // color: new echarts.graphic.LinearGradient(1, 0, 0, 0, [{
                            //     offset: 1,
                            //     color: '#BDDB46'
                            // }, {
                            //     offset: 1,
                            //     color: 'rgba(24,144,255,0)'
                            // }]),
                            color: '#BDDB46',
                            barBorderRadius: 2
                        }
                    },
                    data: tranArr
                }]
            };
            const myChart = echarts.init(this.$refs.intention);
            myChart.setOption(option);
            window.addEventListener("resize", () => {
                // 调用 echartsInstance.resize 改变图表的大小
                myChart.resize();
            });
        },
    }
}
</script>

<style lang="scss" scoped>
.chartBackClass{
    width: 300px;
	height: 200px;
    // background-color: #FFFFFF;
    position: relative;
}
#intention {
    // margin-bottom: 10%;
    width: 90%;
    height: 100%;
    margin-top: -80px;
    // background-color: rgb(239, 133, 72);
}
.noDataView{
    position: absolute;
    left: calc(50% - 90px);
    top: calc(41%);
    // left: 0;
    // top: 0;
    width: 180px;
    height: 40px;
    line-height: 40px;
    border-radius: 9px;
    background: #30D0FF50;
    font-weight: 600;
    font-size: 16px;
    text-shadow: 0px 1px 2px rgba(0,0,0,0.5);
    color: #FFFFFF;
    text-align: center;
    z-index: 100;
}
</style>